import React from 'react';
import { Skeleton, Divider } from 'antd';

const SkeletonView = () => {
    return (
        <div className="parentContainer" style={{ width: "100%" }}>
            <div className="leftSubContainer skeleton">
                <Skeleton active paragraph={{ rows: 0 }} title={{ width: 150 }} />
                <Divider />
                <div className="subContainer skeleton">
                    <Skeleton active paragraph={{ rows: 1 }} title={{ width: 200 }} />
                </div>
                <div className="subContainer skeleton">
                    <Skeleton active paragraph={{ rows: 1 }} title={{ width: 200 }} />
                    <div className="supportFlexContainer skeleton">
                        <div className="supportContainer skeleton">
                            <Skeleton active paragraph={{ rows: 1 }} title={{ width: 100 }} />
                        </div>
                    </div>
                </div>
                <div className="subContainer skeleton">
                    <div className="subWhiteContainer skeleton">
                        <Skeleton active paragraph={{ rows: 1 }} title={{ width: 150 }} />
                        <div className="contentContainer">
                            <div className="leftContent skeleton">
                                <Skeleton active paragraph={{ rows: 2 }} title={{ width: 200 }} />
                                <Skeleton active paragraph={{ rows: 3 }} title={{ width: 200 }} />
                            </div>
                            <div className="mediaContainer skeleton">
                                <Skeleton active paragraph={{ rows: 1 }} title={{ width: 150 }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="subContainer mediaSection skeleton">
                    <Skeleton active paragraph={{ rows: 1 }} title={{ width: 200 }} />
                    <Skeleton active paragraph={{ rows: 4 }} title={{ width: 250 }} />
                </div>
            </div>
        </div>
    );
};

export default SkeletonView;
